import { createFileRoute } from "@tanstack/react-router";
import { ApplicationsPage } from "./-pages/applicationsPage";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";

export const Route = createFileRoute("/_dashboard/$datasetSlug/data/applications/list")({
  component: ApplicationsComponent,
});

function ApplicationsComponent() {
  const { datasetSlug } = Route.useParams();
  useBreadCrumbs([{ title: "Applications List", link: `/${datasetSlug}/data/applications/list` }]);

  return <ApplicationsPage key={datasetSlug} datasetSlug={datasetSlug} />;
}
